<template>
  <router-view></router-view>
</template>

<script>
import addTrtcEventMinix from '@/minixs/addTrtcEvent/addTrtcEventMinix';
export default {
  name: 'App',
  mixins: [addTrtcEventMinix]
}
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
